import ExploreProducts, { ExploreProductsProps } from "./ExploreProducts";

export { ExploreProducts, ExploreProductsProps };

export default ExploreProducts;
